import { render, staticRenderFns } from "./JobHistoryDetails.vue?vue&type=template&id=65d1219d&"
import script from "./JobHistoryDetails.vue?vue&type=script&lang=ts&"
export * from "./JobHistoryDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports